import get from 'lodash.get';
import merge from 'lodash.merge';

import { APLAUT_AVAILABILITY_PROP } from '@/constants/settings';

export default {
  namespaced: true,

  state: () => ({
    settings: {},
  }),

  getters: {
    getSettings: (state) => state.settings,
    getSettingByPath: (state) => (path, defaultValue = null) => get(state.settings, path, defaultValue),
    prepayTime: (state) => state.settings.prepayTime || 0,
    prepayTextTYP: (state) => state.settings.prepayTextTYP || '',
    isReviewsAvailable: (state) => state.settings[APLAUT_AVAILABILITY_PROP] || false,
    cartPaymentMessage: (state) => state.settings.cartPaymentMessage || '',
    storageTimeForPickupText: (state) => state.settings.storageTimeForPickupText || '',
    extensionOrderPickpoint: (state) => state.settings.extensionOrderPickpoint || {},
    deliveryTermsOnProductCard: (state) => state.settings.deliveryTermsOnProductCard || {},
    prolongation: (state) => state.settings.prolongation || {},
  },

  mutations: {
    setSettings: (state, value) => {
      state.settings = merge(state.settings, value);
    },
  },

  actions: {
    async fetchSettings({ commit }, props = {}) {
      const settings = await this.$apiBFF.getSettings(props);

      commit('setSettings', settings);
    },
  },
};
